/**
 * AI Assistant Toggle Button
 *
 * Button to toggle the AI Assistant sidebar open/closed.
 * Shows notification dot when there are unread messages.
 */

import { type Component } from 'solid-js';
import { useAssistant } from './AssistantProvider';

interface AssistantToggleProps {
  class?: string;
}

export const AssistantToggle: Component<AssistantToggleProps> = (props) => {
  const { toggle, state } = useAssistant();

  return (
    <button
      onClick={toggle}
      class={`relative p-2 text-gray-400 hover:text-white hover:bg-purple-500/10 rounded-lg transition-all ${
        state().isOpen ? 'bg-purple-500/20 text-purple-400' : ''
      } ${props.class || ''}`}
      title="AI Assistant"
    >
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
        />
      </svg>

      {/* Gradient ring when active */}
      <span
        class={`absolute inset-0 rounded-lg transition-opacity ${
          state().isOpen ? 'opacity-100' : 'opacity-0'
        }`}
        style={{
          background: 'linear-gradient(to right, rgba(168, 85, 247, 0.2), rgba(236, 72, 153, 0.2))',
          'box-shadow': '0 0 8px rgba(168, 85, 247, 0.3)',
        }}
      />
    </button>
  );
};
